import {Chip, Input} from '@ds/components';

type ClickSelectorProps = {
  clickValue: number | string | null;
  setClickValue: (value: number | string) => void;
  clickBuckets?: number[];
};

const ClickSelector: React.FC<ClickSelectorProps> = ({clickValue, setClickValue, clickBuckets}) => {
  return (
    <section className="flex flex-col gap-2.5 p-4">
      <Input
        name="click"
        required
        type="number"
        inputMode="numeric"
        label="تعداد کلیک"
        placeholder="مقدار دلخواه کلیک"
        value={clickValue ?? ''}
        onChange={(event) => setClickValue(event.target.value)}
      />
      <div className="flex flex-wrap justify-evenly gap-2">
        {clickBuckets?.map((item) => (
          <Chip
            key={item}
            label={`${item} کلیک`}
            interactive
            selected={Number(clickValue) === item}
            onClick={() => setClickValue(item)}
          />
        ))}
      </div>
    </section>
  );
};

export default ClickSelector;
